import useEntity from "../../hooks/useRoleAssignment";
import RoleAssignmentDetail from "../../components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail";
import RoleAssignmentScoped from "../../components/roleAssignment/RoleAssignmentDetail/RoleAssignmentScoped";
import RoleAssignmentTabs from "../../components/roleAssignment/RoleAssignmentDetail/RoleAssignmentTabs";
import { useGetRoleAssignmentQuery } from "../../apis/RoleAssignment.api";
import { PrimaryRoleAssignment } from "../../types/models/RoleAssignment";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoleAssignmentDetailPage = () => {

    useTitle(t`Details Role Assignment`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { roleAssignmentId: id } = useParams();

    const { data, refetch } = useGetRoleAssignmentQuery(PrimaryRoleAssignment.fromPath(id))
    const { deleteRoleAssignment } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteRoleAssignment(data, '..')
    }, [data, deleteRoleAssignment])

    if (id === 'scoped') {
        return (<RoleAssignmentScoped/>)
    }

    return (
        <Box data-testid="RoleAssignment-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <RoleAssignmentDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/RoleAssignments/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="RoleAssignment-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <RoleAssignmentTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default RoleAssignmentDetailPage;
